import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Modalable, ResponseStatus } from './modalable';
import { Loggable } from './loggable';
import { Position } from './position';
import { Features } from '@lemberger/fit-menu';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class QuickLink extends MoveableBookFeature implements Loggable, Modalable {
    static MODAL_ID = 'quicklinkModal';
    link: string;
    found = -1;
    preview: boolean;
    isSignable: boolean;
    isSolutionLink: boolean;
    wasClicked: boolean;
    zIndex = 6;
    dropdownLink = '';
    dropdownPossition: Position;
    menu?: Features | { [k: string]: any };
    type: QuickLinkType;
    combinedLink: string;
    tmpRedirect = false;
    bypassCheck = false;
    logType: TechnicalFeature;
    tool: string | null;
    /**
     * Tells if there should be an AreaLink beside the Quicklink
     */
    showSolution: boolean;
    redirect: string;
    slug: string;
    modalData = { tested: false, err: null };
    /*
    Tells if the Quicklinks should be open in a new Tab or an IFrame.
    If the number is greater then 0, open in new tab.
    Why this is a number? Ask HAM.
     */
    external: number;
    status: ResponseStatus;
    custom_worksheet_updated_at?: number;
    custom_worksheet_id?: string;
    custom_assignments?: string;
    custom_worksheet_title?: string;

    _solutionLink: QuickLink;

    get solutionLink(): QuickLink {
        return this._solutionLink;
    }

    set solutionLink(value: QuickLink) {
        this._solutionLink = value;
    }

    getStatus(): ResponseStatus {
        return this.status;
    }

    getEndpointName(): string {
        return environment.endpointUrls.readspeakerElements;
    }

    getModalId(): string {
        return QuickLink.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }

    isDigi(): boolean {
        return this.type === QuickLinkType.DIGI;
    }

    isESquirrel(): boolean {
        return this.type === QuickLinkType.E_SQUIRREL;
    }

    isCalcuflow(): boolean {
        return this.type === QuickLinkType.CALCUFLOW;
    }

    isGMT(): boolean {
        return this.type === QuickLinkType.GMT;
    }

    isHSM(): boolean {
        return this.type === QuickLinkType.HSM;
    }

    isOther(): boolean {
        return this.type === QuickLinkType.OTHER;
    }

    isYedo(): boolean {
        return this.type === QuickLinkType.YEDO;
    }

    isPhase(): boolean {
        return this.type === QuickLinkType.PHASE;
    }

    isSIA(): boolean {
        return this.type === QuickLinkType.SIA;
    }

    isDigiFit(): boolean {
        return (this.type === QuickLinkType.DIGI_FIT);
    }

    isEduSuite(): boolean {
        return this.type === QuickLinkType.EDU_SUITE;
    }

    isMathion(): boolean {
        return this.type === QuickLinkType.MATHION;
    }

    isDigbi(): boolean {
        return this.type === QuickLinkType.DIGBI;
    }

    isEduvidual(): boolean {
        return this.type === QuickLinkType.EDUVIDUAL;
    }

    isMatheGym(): boolean {
        return this.type === QuickLinkType.MATHE_GYM;
    }

    isMathe4Alle(): boolean {
        return this.type === QuickLinkType.MATHE4ALLE;
    }
}

export enum QuickLinkType {
    E_SQUIRREL,
    GMT,
    HSM,
    OTHER,
    DIGI,
    YEDO,
    PHASE,
    SIA,
    DIGI_FIT,
    CALCUFLOW,
    EDU_SUITE,
    MATHION,
    DIGBI,
    MATHE_GYM,
    MATHE4ALLE,
    EDUVIDUAL
}
